import { ReviewRequestView, ReviewView } from '@zola/svc-marketplace-ts-types';

import { createAction } from '@reduxjs/toolkit';

const REQUESTING_REVIEW = 'zola/marketplace-reviews/REQUESTING_REVIEW';
const RECEIVED_REVIEW = 'zola/marketplace-reviews/RECEIVED_REVIEW';
const UPDATING_REVIEW = 'zola/marketplace-reviews/UPDATING_REVIEW';
const UPDATED_REVIEW = 'zola/marketplace-reviews/UPDATED_REVIEW';
const REVIEW_NOT_FOUND = 'zola/marketplace-reviews/REVIEW_NOT_FOUND';
const REVIEW_NONCE_MISMATCH = 'zola/marketplace-reviews/REVIEW_NONCE_MISMATCH';

export const requestingReview = createAction(REQUESTING_REVIEW);
export const receivedReview = createAction<ReviewRequestView>(RECEIVED_REVIEW);
export const reviewNotFound = createAction<string>(REVIEW_NOT_FOUND);
export const updatingReview = createAction(UPDATING_REVIEW);
export const updatedReview = createAction<ReviewView>(UPDATED_REVIEW);
export const reviewNonceMismatch =
  createAction<{ uuid: string; nonce: string | null | undefined }>(REVIEW_NONCE_MISMATCH);
